import gql from 'graphql-tag';

const DELETE_POLL = gql`
    mutation deletePoll($input: PollInput) {
        deletePoll (input: $input) {
            internalCode
        }
    }
`;

export default DELETE_POLL;
